
/**
 * Enum of activities used to control access on the client.
 */
export enum Activities {
  AggregatorCampaignList = 3005,
  CarrierCampaignList = 3003,

  CampaignListActionMenu = 3100,
  CampaignClone = 3101,
  CampaignWithdraw = 3102,
  CampaignSubmit = 3103,
  CampaignAllowReview = 3104,
  CampaignManageDelegates = 3105,
  CampaignCreateNew = 3150,
  CampaignCommentToCarrier = 3151,

  CampaignCarrierCertify = 3042,
  CampaignAggregatorCertify = 3043,
  CampaignRequestSuspension = 3153,
  CampaignRequestRestoration = 3154,
  CampaignRequestTermination = 3155

}

/**
 * User roles in Campaign Central.
 */
export enum Roles {
  SecurityAdmin = 2,
  CustomerUser = 3000,
  CustomerAdmin = 3005,
  ServiceDesk = 4000
}
